import React from "react";
import Navbar from "../../components/navbar/Navbar";
import ViewProduct from "../../components/product/ViewProduct";

const ViewProductPage = () => {
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          {/* Navbar */}
          <div className="row">
            <div className="col-12 p-0">
              <Navbar content="VIEW PRODUCT" />
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <ViewProduct />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewProductPage;
